import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    token: null,
    nombre: null,
    apellido: null,
    correo: null,
    organismosPermitidos: null,
    rol: null,
    isAuthenticated: false,
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    const nombre = localStorage.getItem("userName");
    const apellido = localStorage.getItem("userApellido");
    const correo = localStorage.getItem("userCorreo");
    const organismosPermitidos = localStorage.getItem("userOrganismosPermitidos");
    const rol = localStorage.getItem("userRol");


    if (token && nombre && rol) {
      setAuth({
        token,
        nombre,
        apellido,
        correo,
        organismosPermitidos,
        rol,
        isAuthenticated: true,
      });
    }
  }, []);

  // const login = (data) => {
  //   // ✅ Almacenamos token, nombre y rol del backend
  //   localStorage.setItem("token", data.token);
  //   localStorage.setItem("userName", data.usuario.nombre);
  //   localStorage.setItem("userApellido", data.usuario.apellido);
  //   localStorage.setItem("userCorreo", data.usuario.correo);
  //   localStorage.setItem("userOrganismosPermitidos", data.usuario.organismosPermitidos);
  //   localStorage.setItem("userRol", data.usuario.rol);

  //   setAuth({
  //     token: data.token,
  //     nombre: data.usuario.nombre,
  //     apellido: data.usuario.apellido,
  //     correo: data.usuario.correo,
  //     organismosPermitidos: data.usuario.organismosPermitidos,
  //     rol: data.usuario.rol,
  //     isAuthenticated: true,
  //   });
  // };

  const login = (data) => {
    const organismoMinero = "67dc3c401333062c757316ef";
  
    const { usuario, token } = data;
    const { nombre, apellido, correo, organismosPermitidos, rol } = usuario;
  
    const tieneAcceso =
      rol === "Dios" ||
      (Array.isArray(organismosPermitidos) &&
        organismosPermitidos.some(org => org === organismoMinero || org._id === organismoMinero));
  
    if (!tieneAcceso) {
      window.Swal.fire({
        icon: 'error',
        title: 'Acceso denegado',
        text: 'No tienes acceso a este organismo.',
      });
      return;
    }
  
    localStorage.setItem("token", token);
    localStorage.setItem("userName", nombre);
    localStorage.setItem("userApellido", apellido);
    localStorage.setItem("userCorreo", correo);
    localStorage.setItem("userOrganismosPermitidos", JSON.stringify(organismosPermitidos));
    localStorage.setItem("userRol", rol);
  
    setAuth({
      token,
      nombre,
      apellido,
      correo,
      organismosPermitidos,
      rol,
      isAuthenticated: true,
    });
  };
  



  const logout = () => {
    localStorage.clear();
    setAuth({
      token: null,
      nombre: null,
      apellido: null,
      correo: null,
      organismosPermitidos: null, 
      rol: null,
      isAuthenticated: false,
    });
  };

  return (
    <AuthContext.Provider value={{ ...auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
